var _ellipse, _path, _path2, _path3, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _mask5, _rect5, _mask6, _rect6, _mask7, _rect7, _mask8, _rect8, _mask9, _rect9, _mask10, _rect10, _mask11, _rect11, _mask12, _rect12, _mask13, _rect13, _mask14, _rect14, _mask15, _rect15, _mask16, _rect16, _mask17, _rect17, _mask18, _rect18, _mask19, _rect19, _mask20, _rect20, _mask21, _rect21, _mask22, _rect22, _mask23, _rect23, _mask24, _rect24, _mask25, _rect25, _mask26, _rect26, _mask27, _rect27, _mask28, _rect28, _mask29, _rect29, _mask30, _rect30, _mask31, _rect31, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _mask32, _rect32, _mask33, _rect33, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 544,
    height: 582,
    viewBox: "0 0 544 582",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.805,
    cy: 539.692,
    rx: 251.805,
    ry: 24.5189,
    fill: "white",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M525.799 532H201.589C193.194 532 186.336 525.142 186.336 516.747V18.2528C186.336 9.85784 193.135 3 201.589 3H525.799C534.194 3 541.052 9.85784 541.052 18.2528V516.747C541.052 525.201 534.194 532 525.799 532Z",
    fill: "white",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M498.252 540.158H174.042C165.647 540.158 158.789 533.3 158.789 524.905V26.411C158.789 18.016 165.647 11.1582 174.042 11.1582H498.252C506.647 11.1582 513.505 18.016 513.505 26.411V524.905C513.505 533.359 506.706 540.158 498.252 540.158Z",
    fill: "white",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M470.229 548.317H146.018C137.623 548.317 130.766 541.519 130.766 533.064V34.5702C130.766 26.1752 137.623 19.3174 146.018 19.3174H470.229C478.624 19.3174 485.482 26.1752 485.482 34.5702V533.064C485.482 541.519 478.624 548.317 470.229 548.317Z",
    fill: "white",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.57,
    y: 66.0488,
    width: 179.027,
    height: 14.7892,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 166.57,
    y: 66.0488,
    width: 179.027,
    height: 14.7892,
    rx: 2,
    fill: "#B5C2CC",
    stroke: "#2D4D5D",
    strokeWidth: 10,
    mask: "url(#path-5-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 92.8623,
    width: 281.408,
    height: 10.6415,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 92.8623,
    width: 281.408,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-6-inside-2)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 110.598,
    width: 253.031,
    height: 10.6415,
    rx: 2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 110.598,
    width: 253.031,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-7-inside-3)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 128.334,
    width: 271.949,
    height: 10.6415,
    rx: 2
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 128.334,
    width: 271.949,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-8-inside-4)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 146.069,
    width: 264.263,
    height: 10.6415,
    rx: 2
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 146.069,
    width: 264.263,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-9-inside-5)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 163.805,
    width: 156.666,
    height: 10.6415,
    rx: 2
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 163.805,
    width: 156.666,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-10-inside-6)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 215.83,
    width: 276.679,
    height: 10.6415,
    rx: 2
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 215.83,
    width: 276.679,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-11-inside-7)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 233.566,
    width: 238.251,
    height: 10.6415,
    rx: 2
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 233.566,
    width: 238.251,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-12-inside-8)"
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-inside-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 251.302,
    width: 260.125,
    height: 10.6415,
    rx: 2
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 251.302,
    width: 260.125,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-13-inside-9)"
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-14-inside-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 269.038,
    width: 248.301,
    height: 10.6415,
    rx: 2
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 269.038,
    width: 248.301,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-14-inside-10)"
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 286.773,
    width: 228.201,
    height: 10.6415,
    rx: 2
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 286.773,
    width: 228.201,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-15-inside-11)"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-16-inside-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 304.51,
    width: 238.251,
    height: 10.6415,
    rx: 2
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 304.51,
    width: 238.251,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-16-inside-12)"
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-17-inside-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 322.245,
    width: 100.503,
    height: 10.6415,
    rx: 2
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 322.245,
    width: 100.503,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-17-inside-13)"
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 374.27,
    width: 253.031,
    height: 10.6415,
    rx: 2
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 374.27,
    width: 253.031,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-18-inside-14)"
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 392.005,
    width: 271.949,
    height: 10.6415,
    rx: 2
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 392.005,
    width: 271.949,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-19-inside-15)"
  })), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 409.741,
    width: 45.5219,
    height: 10.6415,
    rx: 2
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 409.741,
    width: 45.5219,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-20-inside-16)"
  })), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-21-inside-17",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 461.767,
    width: 263.081,
    height: 10.6415,
    rx: 2
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 461.767,
    width: 263.081,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-21-inside-17)"
  })), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-22-inside-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 479.502,
    width: 268.402,
    height: 10.6415,
    rx: 2
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 479.502,
    width: 268.402,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-22-inside-18)"
  })), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-19",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 497.237,
    width: 248.301,
    height: 10.6415,
    rx: 2
  }))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 497.237,
    width: 248.301,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-23-inside-19)"
  })), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "path-24-inside-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 514.974,
    width: 135.975,
    height: 10.6415,
    rx: 2
  }))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 514.974,
    width: 135.975,
    height: 10.6415,
    rx: 2,
    fill: "#D9E5EB",
    stroke: "#5E7987",
    strokeWidth: 10,
    mask: "url(#path-24-inside-20)"
  })), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 194.546,
    width: 86.9054,
    height: 13.0063,
    rx: 2
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 194.546,
    width: 86.9054,
    height: 13.0063,
    rx: 2,
    fill: "#B5C2CC",
    stroke: "#2D4D5D",
    strokeWidth: 10,
    mask: "url(#path-25-inside-21)"
  })), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "path-26-inside-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 352.986,
    width: 153.119,
    height: 13.0063,
    rx: 2
  }))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 352.986,
    width: 153.119,
    height: 13.0063,
    rx: 2,
    fill: "#B5C2CC",
    stroke: "#2D4D5D",
    strokeWidth: 10,
    mask: "url(#path-26-inside-22)"
  })), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-23",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 440.483,
    width: 124.742,
    height: 13.0063,
    rx: 2
  }))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 166.828,
    y: 440.483,
    width: 124.742,
    height: 13.0063,
    rx: 2,
    fill: "#B5C2CC",
    stroke: "#2D4D5D",
    strokeWidth: 10,
    mask: "url(#path-27-inside-23)"
  })), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.496,
    y: 269.037,
    width: 45.5219,
    height: 10.6415,
    rx: 1
  }))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 323.496,
    y: 269.037,
    width: 45.5219,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-28-inside-24)"
  })), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.176,
    y: 251.302,
    width: 66.2137,
    height: 10.6415,
    rx: 1
  }))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 224.176,
    y: 251.302,
    width: 66.2137,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-29-inside-25)"
  })), _mask26 || (_mask26 = /*#__PURE__*/React.createElement("mask", {
    id: "path-30-inside-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.836,
    y: 322.245,
    width: 66.2137,
    height: 10.6415,
    rx: 1
  }))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 179.836,
    y: 322.245,
    width: 66.2137,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-30-inside-26)"
  })), _mask27 || (_mask27 = /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-27",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.402,
    y: 374.271,
    width: 53.2074,
    height: 10.6415,
    rx: 1
  }))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 222.402,
    y: 374.271,
    width: 53.2074,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-31-inside-27)"
  })), _mask28 || (_mask28 = /*#__PURE__*/React.createElement("mask", {
    id: "path-32-inside-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353.648,
    y: 392.006,
    width: 51.4338,
    height: 10.6415,
    rx: 1
  }))), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 353.648,
    y: 392.006,
    width: 51.4338,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-32-inside-28)"
  })), _mask29 || (_mask29 = /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-29",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.176,
    y: 461.767,
    width: 54.3898,
    height: 10.6415,
    rx: 1
  }))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 224.176,
    y: 461.767,
    width: 54.3898,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-33-inside-29)"
  })), _mask30 || (_mask30 = /*#__PURE__*/React.createElement("mask", {
    id: "path-34-inside-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 319.949,
    y: 479.503,
    width: 47.8867,
    height: 10.6415,
    rx: 1
  }))), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 319.949,
    y: 479.503,
    width: 47.8867,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-34-inside-30)"
  })), _mask31 || (_mask31 = /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-31",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 267.332,
    y: 514.975,
    width: 35.4716,
    height: 10.6415,
    rx: 1
  }))), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 267.332,
    y: 514.975,
    width: 35.4716,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-35-inside-31)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201 86.6543L206.084 579",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.227 579L153.174 86.6543",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201 103.208H152.699",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201 142.759H152.699",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.001 182.31H151.281",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M202.186 221.92H150.102",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M202.184 261.47H149.449",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.182 301.021H147.852",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M203.661 340.572H146.492",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M204.076 380.182H145.844",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M203.839 419.733H144.129",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M204.725 459.284H143.359",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M204.487 498.834H143.062",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M204.488 538.444H141.289",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask32 || (_mask32 = /*#__PURE__*/React.createElement("mask", {
    id: "path-50-inside-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 216.047,
    y: 146.068,
    width: 66.2137,
    height: 10.6415,
    rx: 1
  }))), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 216.047,
    y: 146.068,
    width: 66.2137,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-50-inside-32)"
  })), _mask33 || (_mask33 = /*#__PURE__*/React.createElement("mask", {
    id: "path-51-inside-33",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.023,
    y: 110.597,
    width: 35.4716,
    height: 10.6415,
    rx: 1
  }))), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 288.023,
    y: 110.597,
    width: 35.4716,
    height: 10.6415,
    rx: 1,
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 8,
    mask: "url(#path-51-inside-33)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.173 144.295H209.984V158.484H224.173V144.295Z",
    fill: "#F9BA27",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M163.722 273.648C167.328 275.835 171.762 275.717 175.96 275.599C177.201 275.54 178.443 275.481 179.566 275.067C181.103 274.476 182.345 273.175 183.35 271.815C185.714 268.564 187.251 264.662 187.606 260.642C187.665 259.755 187.724 258.75 187.251 257.981C186.838 257.272 186.128 256.858 185.419 256.444C179.566 253.074 173.24 249.586 166.56 250.296C161.712 250.769 156.568 254.552 157.101 259.873C157.633 264.898 159.111 270.81 163.722 273.648Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M180.985 376.575C180.985 376.575 176.256 380.359 177.32 383.551C178.384 386.744 179.567 390.527 180.69 393.069C181.813 395.612 183.114 404.302 187.784 404.302C192.455 404.302 191.804 404.952 191.568 400.519C191.331 396.085 188.967 388.222 188.967 388.222L188.434 378.822L180.985 376.575Z",
    fill: "white",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M361.241 215.948H221.956C218.35 215.948 215.453 212.874 215.453 209.031V182.368C215.453 178.525 218.35 175.451 221.956 175.451H235.731L246.964 153.163L258.965 175.451H361.301C364.907 175.451 367.804 178.525 367.804 182.368V209.031C367.745 212.815 364.848 215.948 361.241 215.948Z",
    fill: "white",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M311.878 207.08C318.147 207.08 323.229 201.998 323.229 195.729C323.229 189.46 318.147 184.378 311.878 184.378C305.609 184.378 300.527 189.46 300.527 195.729C300.527 201.998 305.609 207.08 311.878 207.08Z",
    fill: "#41D592",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M249.862 184.378H227.16V207.08H249.862V184.378Z",
    fill: "#F9BA27",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M353.495 196.498L344.568 207.79L335.641 196.498L344.568 185.206L353.495 196.498Z",
    fill: "#FB7348",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M275.518 207.139L288.111 185.383H262.926L275.518 207.139Z",
    fill: "#9BD7F1",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M144.33 247.459C144.803 245.449 143.62 243.498 143.325 241.488C142.97 239.242 143.266 231.911 144.034 229.783C144.625 228.068 145.217 226.413 145.808 224.698C146.399 224.698 147.345 230.255 147.522 230.788C147.7 231.32 147.64 231.911 147.64 232.502C147.581 233.803 147.759 235.103 148.113 236.345C148.232 236.818 148.645 237.409 149.118 237.232C149.473 237.113 149.532 236.699 149.591 236.345C149.828 234.808 150.064 233.33 150.301 231.793C150.774 231.733 151.247 232.147 151.483 232.561C152.843 234.63 152.547 237.35 151.897 239.655C151.188 242.02 150.123 244.267 149.946 246.75",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M144.33 247.459C144.803 245.449 143.62 243.498 143.325 241.488C142.97 239.242 143.266 231.911 144.034 229.783C144.625 228.068 145.217 226.413 145.808 224.698C146.399 224.698 147.345 230.255 147.522 230.788C147.7 231.32 147.64 231.911 147.64 232.502C147.581 233.803 147.759 235.103 148.113 236.345C148.232 236.818 148.645 237.409 149.118 237.232C149.473 237.113 149.532 236.699 149.591 236.345C149.828 234.808 150.064 233.33 150.301 231.793C150.774 231.733 151.247 232.147 151.483 232.561C152.843 234.63 152.547 237.35 151.897 239.655C151.188 242.02 150.123 244.267 149.946 246.75",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M150.894 268.327L151.071 247.104L142.794 247.931C142.794 247.931 139.484 288.428 142.144 289.847C144.804 291.266 151.544 289.374 151.544 289.374L162.481 271.52",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.894 268.327L151.071 247.104L142.794 247.931C142.794 247.931 139.484 288.428 142.144 289.847C144.804 291.266 151.544 289.374 151.544 289.374L162.481 271.52",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M161.595 259.637L161.358 298.774H177.911L190.977 297.533C190.977 297.533 191.805 270.101 192.455 265.076C193.105 260.051 190.918 261.588 190.918 261.588C190.918 261.588 193.815 258.455 197.421 259.637C201.027 260.819 223.256 266.613 226.153 265.667C229.05 264.721 239.691 225.111 239.691 223.397C239.691 221.682 232.183 220.5 232.183 220.5L220.123 253.311C220.123 253.311 201.264 248.7 197.421 245.803C193.578 242.906 186.543 240.246 186.543 240.246L174.719 241.96C174.719 241.96 158.52 241.724 156.865 245.094C155.21 248.463 148.766 274.831 148.766 274.831",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M161.595 259.637L161.358 298.774H177.911L190.977 297.533C190.977 297.533 191.805 270.101 192.455 265.076C193.105 260.051 190.918 261.588 190.918 261.588C190.918 261.588 193.815 258.455 197.421 259.637C201.027 260.819 223.256 266.613 226.153 265.667C229.05 264.721 239.691 225.111 239.691 223.397C239.691 221.682 232.183 220.5 232.183 220.5L220.123 253.311C220.123 253.311 201.264 248.7 197.421 245.803C193.578 242.906 186.543 240.246 186.543 240.246L174.719 241.96C174.719 241.96 158.52 241.724 156.865 245.094C155.21 248.463 148.766 274.831 148.766 274.831",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M157.279 400.695L155.505 408.913C155.505 408.913 153.85 412.46 155.505 413.406C157.161 414.352 159.762 418.608 162.54 419.318C165.378 420.027 169.871 419.613 169.871 419.613C169.871 419.613 175.074 417.248 173.182 415.593C171.29 413.938 168.63 411.514 168.63 411.514L166.147 405.129L164.728 399.749L157.279 400.695Z",
    fill: "white",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M161.357 298.715C161.357 298.715 157.278 310.184 157.278 316.451C157.278 322.718 161.357 352.1 161.357 352.1L155.859 400.873L165.851 400.814L168.452 391.946L175.073 352.159L177.497 325.26L187.961 350.267L180.985 376.575C180.985 376.575 185.183 375.511 187.961 379.354C190.74 383.197 204.042 342.345 204.042 342.345L194.228 312.313L190.976 297.474L161.357 298.715Z",
    fill: "#182232",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M187.725 207.73C190.799 210.982 192.573 215.416 192.514 219.909C192.514 222.215 192.041 224.579 191.391 226.708C190.74 228.836 189.262 229.664 188.316 230.905C187.371 232.147 185.893 233.093 184.355 233.034",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M187.725 207.73C190.799 210.982 192.573 215.416 192.514 219.909C192.514 222.215 192.041 224.579 191.391 226.708C190.74 228.836 189.262 229.664 188.316 230.905C187.371 232.147 185.893 233.093 184.355 233.034",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M178.326 200.163C182.583 199.808 192.101 203.888 190.623 209.681C189.204 215.475 186.248 219.732 186.367 224.638C186.367 225.466 186.485 226.412 186.958 227.062C187.431 227.713 188.14 228.067 188.613 228.718C189.736 230.137 189.263 232.206 188.377 233.743C187.49 235.28 186.307 236.758 186.071 238.532C185.716 241.192 190.623 240.896 189.796 243.438C188.968 246.099 185.657 247.163 184.357 249.705C183.351 251.715 183.824 254.375 182.465 256.208C180.75 258.455 177.144 257.982 174.661 256.563C172.178 255.144 169.931 253.075 167.094 252.72C164.788 252.425 162.187 253.252 160.354 251.892C158.285 250.355 158.64 247.104 159.586 244.68C160.531 242.256 161.891 239.596 160.945 237.172C160.354 235.635 158.994 234.511 158.344 233.033C156.511 229.072 160.058 224.816 160.768 220.559C161.123 218.431 162.66 216.716 162.482 214.588C162.128 210.568 164.433 204.361 168.513 203.001C172.237 201.818 174.484 200.518 178.326 200.163Z",
    fill: "#182232",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M234.014 219.731C233.66 216.243 232.714 211.159 234.96 208.558C235.315 208.144 236.438 208.972 236.734 208.558C237.088 208.085 237.266 207.494 237.443 206.902C237.916 205.424 238.389 203.946 238.921 202.468C239.158 201.818 239.394 201.109 239.867 200.636C240.34 200.163 241.168 199.867 241.759 200.222C242.409 202.646 241.109 205.129 241.227 207.612C241.286 209.09 244.124 210.627 244.419 212.105C245.07 215.593 241.936 219.199 239.867 222.096",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M234.014 219.731C233.66 216.243 232.714 211.159 234.96 208.558C235.315 208.144 236.438 208.972 236.734 208.558C237.088 208.085 237.266 207.494 237.443 206.902C237.916 205.424 238.389 203.946 238.921 202.468C239.158 201.818 239.394 201.109 239.867 200.636C240.34 200.163 241.168 199.867 241.759 200.222C242.409 202.646 241.109 205.129 241.227 207.612C241.286 209.09 244.124 210.627 244.419 212.105C245.07 215.593 241.936 219.199 239.867 222.096",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.664 115.623L291.865 124.195L285.066 115.623L291.865 107.051L298.664 115.623Z",
    fill: "#FB7348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.664 115.623L291.865 124.195L285.066 115.623L291.865 107.051L298.664 115.623Z",
    stroke: "#182232",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 279.566,
    y: 101.551,
    width: 32.5975,
    height: 36.1446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.12549 0 0 0 0 0.262745 0 0 0 0 0.329412 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIllustration);
export default __webpack_public_path__ + "static/media/loginIllustration.fde36413238fc4b436779880639433e2.svg";
export { ForwardRef as ReactComponent };